import "bootstrap/js/dist/tab"
import Faq from "../modules/faq"

new Faq('.section-content-tabs-mobile')